import { useMemo } from 'react';

const useArray = (...elements) => {
  return useMemo(() => elements, [...elements]);
};

export default useArray;
